import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { showModal, hideModal } from '../store/slices/modals/modalsSlice';

const useModals = () => {
  const dispatch = useDispatch();
  const { modalType, modalProps } = useSelector((state: RootState) => state.modals);

  const openModal = (modalType: string, modalProps: any = {}) => {
    dispatch(showModal({ modalType, modalProps }));
  };

  const closeModal = () => {
    dispatch(hideModal());
  };

  return {
    modalType,
    modalProps,
    openModal,
    closeModal,
  };
};

export default useModals;
